module.exports = __webpack_public_path__ + "img/minsafb.d349dac7.png";